define('components/tooltip/models/tooltip',[], function() {

    "use strict";
    var Model = Backbone.Model.extend({

        /**
         * Model constants
         * @attribute constants
         * @type Object
         * @default null
         */
        "constants": null,

        /**
         * Defaults of model attributes
         * @method defaults
         * @public
         * @returns {Function} Defaults
         */
        "defaults": function() {
            return {

                "tooltipConfig": 0,

                "animationConfig": null,

                "geometry": null, // Format { "left": 0, "top": 0, "height": 0, "width": 0 }

                "targetEle": null,

                "position": null,

                "textContent": null,

                "template": null,

                "containerEle": null,

                "baseClass": null
            };
        },

        /**
         * Initializes Model
         * @method initialize
         * @public
         */
        "initialize": function() {
            this.constants = Model.CONSTANTS;
            this.set("geometry", this.get("geometry") || {});
        },

        /**
         * Sets text of the tooltip
         * @method setText
         * @public
         * @param {String} textContent String text to be set in the tooltip.
         */
        "setText": function(textContent) {
            this.set("textContent", textContent);
        },

        /**
         * Sets template for the tooltip
         * @method setTemplate
         * @public
         * @param {Object} template Template for the view
         */
        "setTemplate": function(template) {
            this.set("template", template);
        },

        /**
         * Sets geometry
         * @method setGeometry
         * @public
         * @param {Object} geometry, object containing top and left position of tooltip
         */
        "setGeometry": function(geometry) {
            geometry = geometry || this.get("geometry");
            this.set("geometry", geometry);
        },

        /**
         * Update bounds value
         * @method updateBounds
         * @param {Object} bounds hotspot position and size
         * @chainable
         */
        "updateBounds": function(bounds) {
            var obj,
                modelBounds = this.get("geometry");
            for (obj in bounds) {
                if (modelBounds.hasOwnProperty(obj)) {
                    modelBounds[obj] = Number(bounds[obj]);
                }
            }
            return this;
        }
    }, {
        "CONSTANTS": {
            "TOOLTIP_HIDE_ARROW": 1,
            "TOOLTIP_HAS_CLOSE_BTN": 2,
            "TOOLTIP_AUTO_HIDE": 4,
            "TOOLTIP_IS_PERMANENT": 8,
            "TOOLTIP_ANIMATE": 16,
            "TOOLTIP_DYNAMIC_POSITION": 32,
            "TOOLTIP_DRAGGABLE": 64,
            "TOOLTIP_RESIZABLE": 128,
            "TOOLTIP_FIXED_POSITION": 256
        }
    });
    return Model;
});

